import React from "react";
import { Document, Page } from "react-pdf";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";

import "./Resume.scss";

const iframeStyle = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  border: "none",
  padding: 0,
  margin: 0,
};

const Resume = () => {
  return (
    <div className="app__resume">
      <div className="resume-container">
        <iframe
          loading="lazy"
          style={iframeStyle}
          src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFYDxVkTPU&#x2F;view?embed"
          allow="fullscreen"
          allowFullScreen="allowfullscreen"
        ></iframe>
      </div>
      <a
        className="resume-link"
        href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFYDxVkTPU&#x2F;view?utm_content=DAFYDxVkTPU&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link"
        target="_blank"
        rel="noopener"
      >
        Click here to view on Canva
      </a>{" "}
    </div>
  );
};

export default AppWrap(
  MotionWrap(Resume, "app__resume"),
  "resume",
  "app__primarybg"
);
